import React from "react";
import "./Progress.scss";
import {techStack} from "../../portfolio";
import {Fade} from "react-reveal";

export default function StackProgress() {
  if (techStack.viewSkillBars) {
    return (
      <Fade bottom duration={1000} distance="20px">
        <div className="proficiency-container" id="proficiency">
          <h1 className="proficiency-heading">Proficiency</h1>
          <div className="proficiency-grid">
            {techStack.experience.map((exp, i) => {
              const progressStyle = {
                width: exp.progressPercentage
              };
              return (
                <div key={i} className="proficiency-skill">
                  <div className="proficiency-skill-top">
                    <p className="proficiency-skill-name">{exp.Stack}</p>
                    <p className="proficiency-skill-percent">
                      {exp.progressPercentage}
                    </p>
                  </div>
                  <div className="proficiency-meter">
                    <span style={progressStyle}></span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Fade>
    );
  }
  return null;
}
